webpackJsonp([77],{

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1371);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _enGb = __webpack_require__(851);

var _enGb2 = _interopRequireDefault(_enGb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-gb', _enGb2.default);

/***/ })

},[1370]);


// WEBPACK FOOTER //
// app/datetime.en-gb-c2baa9319ddd7d41e24e.js